import {
  CREATE_COMPONENT_ACROSS_LOCALES_STARTED,
  CREATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_STARTED,
  CREATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_SUCCEEDED,
  CREATE_COMPONENT_ACROSS_LOCALES_PROGRESSED,
  CREATE_COMPONENT_ACROSS_LOCALES_FAILED,
} from '@packages/systems/designer/actions';
import type {DesignerActionFromCreator} from '@packages/systems/designer/flux';
import type {CreateComponentPayload} from '@packages/systems/component-create';
import {createAction} from '@packages/utilities/create-action';

export const createComponentAcrossLocalesStarted = createAction<
  typeof CREATE_COMPONENT_ACROSS_LOCALES_STARTED,
  CreateComponentPayload
>(CREATE_COMPONENT_ACROSS_LOCALES_STARTED);

export type CreateComponentAcrossLocalesStartedAction =
  DesignerActionFromCreator<typeof createComponentAcrossLocalesStarted>;

export const createComponentAcrossLocalesEnqueueStarted = createAction<
  typeof CREATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_STARTED,
  CreateComponentPayload
>(CREATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_STARTED);

export type CreateComponentAcrossLocalesEnqueueStartedAction =
  DesignerActionFromCreator<typeof createComponentAcrossLocalesEnqueueStarted>;

export const createComponentAcrossLocalesEnqueueSucceeded = createAction<
  typeof CREATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_SUCCEEDED,
  {taskId: string}
>(CREATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_SUCCEEDED);

export type CreateComponentAcrossLocalesEnqueueSucceededAction =
  DesignerActionFromCreator<
    typeof createComponentAcrossLocalesEnqueueSucceeded
  >;

export const createComponentAcrossLocalesProgressed = createAction<
  typeof CREATE_COMPONENT_ACROSS_LOCALES_PROGRESSED,
  {progress: number}
>(CREATE_COMPONENT_ACROSS_LOCALES_PROGRESSED);

export type CreateComponentAcrossLocalesProgressedAction =
  DesignerActionFromCreator<typeof createComponentAcrossLocalesProgressed>;

export const createComponentAcrossLocalesFailed = createAction<
  typeof CREATE_COMPONENT_ACROSS_LOCALES_FAILED
>(CREATE_COMPONENT_ACROSS_LOCALES_FAILED);

export type CreateComponentAcrossLocalesFailedAction =
  DesignerActionFromCreator<typeof createComponentAcrossLocalesFailed>;
